import { SLCSoftCreditCheckContainer } from '../../common/slc/soft-credit-check'

export const OnboardingSLCSoftCreditCheckContainer = () => {
  return <SLCSoftCreditCheckContainer />
}
